module.exports = __webpack_public_path__ + "static/media/icn-service-default.47b7db82.png";